import * as Yup from 'yup';
import { checkBoxCheckedRequired, emailRequired, nameRequired, passwordRequired, stringRequired } from '.';

export const loginSchema = Yup.object({
    email: emailRequired,
    password: stringRequired
});

export const signupSchema = Yup.object({
    first_name: nameRequired,
    last_name: nameRequired,
    organization_name: nameRequired,
    email: emailRequired,
    password: passwordRequired,
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required'),
    agree_terms: checkBoxCheckedRequired
});

export const updatePasswordSchema = Yup.object({
    oldPassword: stringRequired,
    newPassword: stringRequired,
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('newPassword')], 'Passwords must match')
        .required('Confirm Password is required')
});

export const resetPasswordSchema = Yup.object({
    password: passwordRequired,
    confirm_password: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .required('Confirm Password is required')
});

export const forgetPasswordSchema = Yup.object({
    email: emailRequired
});